import Button from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const ButtonStyled = styled(Button)`
	box-shadow: 0 3.64835px 3.64835px rgba(0, 0, 0, 0.25);
	border-radius: 0.7619em;
	line-height: 1;
	transition: all ease 0.3s;
	text-transform: none;
`;
